import React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';

import * as revealActions from '../../../../actions/revealActions';
import * as accountActions from '../../../../actions/accountActions';
import * as messageAlert from '../../../../actions/messageAlertAction';
import ImageSelectorReveal from '../../../common/reveal/ImageSelectorReveal';

export const AVATAR_SELECTOR_REVEAL = 'avatarSelectorReveal';

export class ProfileAvatarSelectorReveal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.uploadAsset = this.uploadAsset.bind(this);
    this.selectUserAvatar = this.selectUserAvatar.bind(this);
  }

  static propTypes = {
    newUserData: PropTypes.object,
    user: PropTypes.object,
    accountActions: PropTypes.object,
    avatarsImages: PropTypes.any,
    customer: PropTypes.object,
    onUploadAsset: PropTypes.func
  };

  uploadAsset(imageCrop) {
    const { customer, newUserData, accountActions } = this.props;

    return accountActions.uploadUserAvatar(imageCrop, newUserData, customer.id);
  }

  selectUserAvatar(image) {
    const { user, accountActions } = this.props;

    let newUser = _.cloneDeep(user);
    newUser.picture = image;
    newUser.avatar = image;
    newUser.pictureType = 'AVATAR';
    accountActions.setNewUserData(newUser);
  }

  render() {
    const { avatarsImages, newUserData } = this.props;

    return (
      <ImageSelectorReveal
        images={avatarsImages}
        user={newUserData}
        itemClass={'xs'}
        classroomAsset={'true'} // TODO: remove when user profile image is refactored
        uploadAsset={this.uploadAsset}
        selectedImage={newUserData.picture}
        selectAvatarCallback={this.selectUserAvatar}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    avatarsImages: state.theme.images.avatars,
    newUserData: state.account.newUserData,
    user: state.account.user,
    customer: state.school.school.customer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    revealActions: bindActionCreators(revealActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAvatarSelectorReveal);
